import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ProductCustomProductSpec } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductCustomProductSpecService extends TmsWebBaseEditCreateService<
  ProductCustomProductSpec,
  ProductCustomProductSpec
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ProductCustomProductSpec', $localize`Product Custom Product Spec`);
  }
}
